<template>
  <v-row
    v-if="
      viewMomCommentPermission || sendMomCommentNotificationPermission
    "
  >
    <v-col cols="12" class="pt-0 pb-0">
      <h4>{{ $t("agenda.lblCirculationProcess") }}</h4>
    </v-col>
    <v-col cols="12">
      <v-tooltip bottom v-if="viewMomCommentPermission">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
            class="mr-2"
            @click.stop="commentToDraft"
            v-if="viewMomCommentPermission"
            :disabled="isMeetingModified"
          >
            {{ $t("lblOpenCirculation") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblCommentToDraft") }}</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="sendMomCommentNotificationPermission"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
            @click.stop="sendNotification"
            v-if="sendMomCommentNotificationPermission"
            :disabled="isMeetingModified"
          >
            {{ $t("agenda.lblSendNotification") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblSendNotification") }}</span>
      </v-tooltip>
    </v-col>
    <mom-draft-comment
      v-if="momCommentDraft"
      v-model="momCommentDraft"
      :meetingObject="meetingObject"
    ></mom-draft-comment>
    <email-alert-notification
      v-if="dialogNotification"
      v-model="dialogNotification"
      :emailTemplate="emailTemplate"
      :defaulter="defaulter"
      :suggestedList="suggestedAttendees"
      @send="onEmailSend"
      type="remind"
      :heading="alertHeading"
    ></email-alert-notification>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
    <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EmailAlertNotification from "@/components/EmailAlertNotification.vue";
import MomDraftComment from "./MomDraftComment.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import Loader from "@/components/Loader.vue";
import { mapActions } from "vuex";
import { formatDate } from "../../../utils/util";
import PlaceholderMixin from "../../../mixin/PlaceholderMixin";

export default {
  name: "MomAnnotation",
  mixins: [PlaceholderMixin],
  components: {
    EmailAlertNotification,
    MomDraftComment,
    MessageSheet,
    Loader,
  },
  props: {
    meetingObject: {
      type: Object,
      default: true,
    },
  },
  data: function () {
    return {
      dialogNotification: false,
      momCommentDraft: false,
      displayMessage: false,
      message: "",
      messageType: "",
      Loaderloading: false,
      alertTemplate: {},
      defaulter: [],
      suggestedAttendees: [],
      alertHeading: this.$t("agenda.hNotification"),
      isMeetingModified: false,
    };
  },
  computed: {
    ...mapState({
      agendaListData: (state) => state.agenda.agendaListByMeetingType,
    }),
    ...gettersMap(),
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    viewMomCommentPermission() {
      if (this.meetingObject.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingObject.meetingTypeId,
          "ViewMomComment"
        );
      }
      return false;
    },
    sendMomCommentNotificationPermission() {
      if (this.meetingObject.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingObject.meetingTypeId,
          "SendMomCommentNotification"
        );
      }
      return false;
    },
    isParticipants() {
      if (this.meetingObject.attendees.length == 0) return false;
      const attendees = this.meetingObject.attendees.flatMap((item) => {
        const mainAttendee = { ...item, email: item.email };
        const additionalAttendees = (item.contactEmailIds || [])
          .filter((email) => email)
          .map((email) => ({ ...item, email }));

        return [mainAttendee, ...additionalAttendees];
      });
      return attendees.some((item) => item.email === this.$auth.user.email);
    },
    emailTemplate: {
      get() {
        return this.alertTemplate;
      },
      set(val) {
        this.alertTemplate = val;
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    displayDateFormat() {
      return this.selectedLang !== "ja"
        ? "dd/MM/yyyy hh:mm aaa"
        : "yyyy/MM/dd HH:mm";
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd/MM/yyyy" : "yyyy/MM/dd";
    },
    getMOMReviewRequestTemplate() {
      return this.getTemplateByTemplateTypeId(
        "MOMReviewRequest",
        this.selectedLang
      );
    },
    topicDetails() {
      const topicCategoryList = this.tenantSettingTypes("topiccategory") || [];

      let maxOrder = topicCategoryList.reduce(
        (max, { order = 0 }) => Math.max(max, order),
        0
      );

      // Assign new order to items that already have an order
      const updatedList = topicCategoryList.map((cat) => {
        const updatedOrder = cat.order ? ++maxOrder : cat.order;
        return { ...cat, order: updatedOrder };
      });

      // Apply getTopicOrder and sort the list
      return updatedList
        .map((item) => ({
          ...item,
          order: this.getTopicOrder(item),
        }))
        .sort((a, b) => a.order - b.order);
    },
    topics() {
      const topics = this.meetingObject?.topics || [];

      return topics.map((item) => ({
        ...item,
        agenda: this.getAgendaDetails(item),
      }));
    },
    agendanumbering() {
      return this.tenantSettingTypes("agendanumbering");
    },
  },
  created() {
    this.$eventHub.$on("meetingDataModified", (value) => {
      this.isMeetingModified = value;
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("meetingDataModified");
  },
  methods: {
    ...mapActions({
      getMomAttendees: "meeting/getMomAttendees",
      getMomComments: "meeting/getMomComments",
    }),
    async commentToDraft() {
      this.Loaderloading = true;
      try {
        await this.getMomComments(this.meetingObject.id);
        this.Loaderloading = false;
        this.momCommentDraft = true;
      } catch (error) {
        this.momCommentDraft = false;
        this.Loaderloading = false;
      }
    },
    trimHtml(html) {
      return html.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async sendNotification() {
      this.Loaderloading = true;

      const attendees = [];
      this.meetingObject.attendees.forEach((item) => {
        attendees.push({
          id: item.id,
          email: item.email,
        });
      });

      let meetingNumbering = 0;

      const catTopics = this.topicDetails
        .map((category) => ({
          ...category,
          topics: this.topics
            .filter((topic) => topic.topicCategory === category.id)
            .sort((a, b) => a.displayOrder - b.displayOrder),
        }))
        .filter((category) => category.topics.length > 0)
        .sort((a, b) => a.order - b.order);

      // Assign meetingNumbering
      catTopics.forEach((category) => {
        category.topics.forEach((topic) => {
          topic.meetingNumbering = ++meetingNumbering;
        });
      });

      let meetingPurpose = catTopics
        .map((category) => {
          const topicsHtml = category.topics
            .map((topic, index) => {
              const number =
                this.agendanumbering === "numbering_for_meeting"
                  ? `${topic.meetingNumbering}.`
                  : this.agendanumbering === "numbering_for_category"
                  ? `${index + 1}.`
                  : "";

              const liStyle =
                this.agendanumbering === "" ||
                this.agendanumbering === "no_numbering"
                  ? ""
                  : "list-style-type: none";

              return `
          <li>
            ${topic.agenda.agendaName}
            <ul>
              <li style="${liStyle}">${number} ${topic.topicName}</li>
            </ul>
          </li>`;
            })
            .join("");

          return `
      <ul style="list-style: none; margin-left: 0; padding-left: 0; font-size: 11pt;">
        <li>${category.name}
          <ul style="list-style: none;">
            ${topicsHtml}
          </ul>
        </li>
      </ul>`;
        })
        .join("");

      const placeHolderVariables = this.replaceMeetingDataPlaceholders(
        this.meetingObject,
        meetingPurpose
      );

      this.alertTemplate = {
        subject: this.getMOMReviewRequestTemplate.subject.replace(
          /{{%[^}]+%}}/g,
          (match) => placeHolderVariables[match] || ""
        ),
        message: this.getMOMReviewRequestTemplate.body.replace(
          /{{%[^}]+%}}/g,
          (match) => placeHolderVariables[match] || ""
        ),
        mailType: "meeting-mom-notification",
        dynamicVariables: {
          targetId: this.meetingObject.id,
          meetingTypeId: this.getMeetingTypeId,
          targetTitle: this.meetingObject.meetingName,
          targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
        },
      };

      const response = await this.getMomAttendees(this.meetingObject.id);
      const momAssignee = response.data.all.map((item) => {
        return { ...item, email: item.registered_email };
      });
      this.suggestedAttendees = momAssignee ?? [];
      this.defaulter = momAssignee;
      this.alertHeading = this.$t("agenda.hNotification");
      this.Loaderloading = false;
      this.dialogNotification = true;
    },
    onEmailSend(isSucess) {
      this.Loaderloading = false;
      if (isSucess) {
        this.showMessageSheet(
          this.$t("agenda.SendEmailNotification"),
          "success"
        );
      } else {
        this.showMessageSheet(
          this.$t("agenda.FaildEmailNotification"),
          "error"
        );
      }
    },
    getTopicOrder,
    getAgendaDetails,
  },
};

function getAgendaDetails(item) {
  return this.agendaListData?.find((f) => f.id === item.agendaId) || {};
}

function getTopicOrder(item) {
  const category = this.meetingObject.topicCategories?.find(
    (f) => f.id === item.id
  );
  return category?.order ?? item.order;
}

function gettersMap() {
  return mapGetters({
    getMeetingTypeId: "meeting/getMeetingTypeId",
    getTemplateByTemplateTypeId: "tenant/getTemplateByTemplateTypeId",
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}
</script>